interface IMaterialCategory {
    id?: number;
    category?: string;
    active?: boolean;
    created?: Date;
    createdByUserId?: number;
    updated?: Date;
    updatedByUserId?: number;
    isBusinessCard?: boolean;
}

class MaterialCategory implements IMaterialCategory {
    public id?: number;
    public category?: string;
    public active?: boolean;
    public created?: Date;
    public createdByUserId?: number;
    public updated?: Date;
    public updatedByUserId?: number;
    public isBusinessCard?: boolean;

    constructor(m: IMaterialCategory = {}) {
        this.id = m.id;
        this.category = m.category;
        this.active = m.active;
        this.created = m.created ? new Date(m.created) : undefined;
        this.createdByUserId = m.createdByUserId;
        this.updated = m.updated ? new Date(m.updated) : undefined;
        this.updatedByUserId = m.updatedByUserId;
        this.active = m.active;
        this.isBusinessCard = this.setIsBusinessCard();
    }

    private setIsBusinessCard() {
        if (this.category && this.category === 'Business Cards') {
            return true;
        } else {
            return false;
        }
    }
}

export default MaterialCategory;
export { MaterialCategory, IMaterialCategory };
